import styled from '@emotion/styled';
import { Button, Text } from '@innovationdepartment/proxima-ui';
import type { BrandProductMetricAttributes, ProductTaxonomyAttributes } from 'types/brandProducts';
import ButtonGroup from 'ui/ButtonGroup';

const TextWrapper = styled.div<{ inline?: boolean }>`
  display: flex;
  flex-direction: ${({ inline }) => (inline ? 'row' : 'column')};
  & p {
    display: inline;
  }

  margin-bottom: 8px;
`;

const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

type ConfirmationViewProps = {
  onConfirm: () => void;
  onCancel: () => void;
  taxonomy?: ProductTaxonomyAttributes;
  products: BrandProductMetricAttributes[];
};

const BrandProductsTaxonomyChangeModalConfirmationView = (props: ConfirmationViewProps) => {
  const { onCancel, onConfirm, taxonomy, products } = props;

  return (
    <ContainerWrapper>
      <TextWrapper>
        <TextWrapper>
          <Text variant="body1">
            Would you like to change the categories for the following products:
          </Text>
        </TextWrapper>
        <TextWrapper>
          {products.map(product => (
            <Text key={product.productId} variant="body1Semibold" color="red40">
              <strong>{product.title}</strong>
            </Text>
          ))}
        </TextWrapper>
        <TextWrapper inline>
          <Text variant="body1">to</Text>
          <Text variant="body1" color="green40">
            &nbsp;<strong>{taxonomy?.name}</strong>
          </Text>
          <Text variant="body1">?</Text>
        </TextWrapper>
      </TextWrapper>
      <ButtonGroup>
        <Button label="Cancel" variant="outlined" onClick={onCancel} />
        <Button label="Confirm" variant="contained" onClick={onConfirm} />
      </ButtonGroup>
    </ContainerWrapper>
  );
};

export default BrandProductsTaxonomyChangeModalConfirmationView;
